// src/ManageEAs.js
import React, { useEffect, useState } from 'react';
import './ManageEAs.css';
import { supabase } from './supabaseClient';
import { FaArrowLeft, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ManageEAs = () => {
  const [botName, setBotName] = useState('');
  const [pairs, setPairs] = useState([]);
  const [pairInput, setPairInput] = useState('');
  const [eaFile, setEaFile] = useState(null);
  const [image, setImage] = useState(null);
  const [userBots, setUserBots] = useState([]);
  const [error, setError] = useState('');
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data, error } = await supabase.auth.getUser();
      if (error || !data?.user) {
        setError('Unable to fetch user session');
        return;
      }
      setUserId(data.user.id);
      fetchBots(data.user.id);
    };

    fetchUser();
  }, []);

  const fetchBots = async (id) => {
    const { data, error } = await supabase
      .from('robot_licenses')
      .select('*')
      .eq('user_id', id);
    if (error) {
      console.error('Failed to fetch bots:', error.message);
      return;
    }
    setUserBots(data);
  };

  const handleAddPair = () => {
    const input = pairInput.trim().toUpperCase();
    if (input && !pairs.includes(input)) {
      setPairs([...pairs, input]);
      setPairInput('');
    }
  };

  const removePair = (index) => {
    const updated = [...pairs];
    updated.splice(index, 1);
    setPairs(updated);
  };

  const deleteBot = async (botId) => {
    const { error } = await supabase.from('robot_licenses').delete().eq('id', botId);
    if (error) {
      setError('Failed to delete bot');
      return;
    }
    fetchBots(userId);
  };

  const handleCreateEA = async () => {
    setError('');
    if (!botName || !eaFile || !image || pairs.length === 0) {
      setError('Please complete all fields.');
      return;
    }

    const timestamp = Date.now();
    const imgPath = `${timestamp}-${image.name}`;
    const filePath = `${timestamp}-${eaFile.name}`;

    const { error: imgError } = await supabase.storage
      .from('bot-images')
      .upload(imgPath, image);
    if (imgError) {
      console.error('Image Upload Error:', imgError.message);
      setError('Image upload failed');
      return;
    }

    const { error: fileError } = await supabase.storage
      .from('ea-files')
      .upload(filePath, eaFile);
    if (fileError) {
      console.error('File Upload Error:', fileError.message);
      setError('EA file upload failed');
      return;
    }

    const newBot = {
      user_id: userId,
      ea_name: botName, // ✅ Corrected field name
      pairs: pairs,
      file_name: filePath,
      image_name: imgPath,
      used: false,
    };

    console.log('Saving EA:', newBot);

    const { error: dbError } = await supabase
      .from('robot_licenses')
      .insert([newBot]);

    if (dbError) {
      console.error('Insert Error:', dbError.message);
      setError(`Failed to save EA to database: ${dbError.message}`);
    } else {
      setBotName('');
      setPairs([]);
      setEaFile(null);
      setImage(null);
      setError('');
      fetchBots(userId);
    }
  };

  return (
    <div className="manage-eas">
      <div className="header">
        <Link to="/dashboard" className="back-arrow"><FaArrowLeft /></Link>
        <h2>Manage Expert Advisors</h2>
      </div>

      <div className="form-section">
        <input
          type="text"
          value={botName}
          onChange={(e) => setBotName(e.target.value)}
          placeholder="Bot Name"
        />

        <div className="pairs-input">
          <input
            type="text"
            value={pairInput}
            onChange={(e) => setPairInput(e.target.value)}
            placeholder="Enter Trading Pair"
          />
          <button onClick={handleAddPair}><FaPlus /></button>
        </div>

        <div className="tag-container">
          {pairs.map((pair, index) => (
            <span className="tag" key={index}>
              {pair}
              <FaTimes className="remove-tag" onClick={() => removePair(index)} />
            </span>
          ))}
        </div>

        <label className="file-label">Upload EA File (ex4/ex5/mql4/mql5)</label>
        <input
          type="file"
          accept=".ex4,.ex5,.mql4,.mql5"
          onChange={(e) => setEaFile(e.target.files[0])}
        />

        <label className="file-label">Upload Bot Image</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
        />

        <button onClick={handleCreateEA} className="create-btn">Create EA 🚀</button>

        {error && <p className="error-msg">{error}</p>}
      </div>

      <div className="bot-list">
        {userBots.map((bot, idx) => (
          <div className="bot-card" key={idx}>
            <img
              src={`https://fvjocckztcchvgyudsyu.supabase.co/storage/v1/object/public/bot-images/${bot.image_name}`}
              alt="Bot"
            />
            <h4>{bot.ea_name}</h4> {/* ✅ Corrected field reference */}
            <div className="tag-container">
              {(bot.pairs || []).map((pair, i) => (
                <span key={i} className="tag">{pair}</span>
              ))}
            </div>
            <button className="delete-btn" onClick={() => deleteBot(bot.id)}>
              <FaTrash />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageEAs;